/**
 * VSPC UI API
 * Internal API
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum UserRoleRepresentation {
    Unknown = 'unknown',
    VacAdministrator = 'vacAdministrator',
    CompanyLocationAdministrator = 'companyLocationAdministrator',
    CompanyLocationUser = 'companyLocationUser',
    CompanyOwner = 'companyOwner',
    Finance = 'finance',
    Subtenant = 'subtenant',
    VacOperator = 'vacOperator',
    ResellerOwner = 'resellerOwner',
    ResellerOperator = 'resellerOperator',
    ResellerUser = 'resellerUser',
    ResellerFinance = 'resellerFinance',
    ResellerAdministrator = 'resellerAdministrator',
    CloudConnectAdministrator = 'cloudConnectAdministrator',
    CompanyAdministrator = 'companyAdministrator',
    VacReadonlyOperator = 'vacReadonlyOperator'
};

